import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccordionComponent, AccordionPanelDirective } from '@libs/common/components';
import { AccordionContentModel } from '@libs/cms/models';
import { HtmlDataLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-content-accordion',
  templateUrl: './accordion-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadlinesComponent,
    AccordionPanelDirective,
    AccordionComponent,
    HtmlDataLinkDirective,
  ],
})
export class AccordionContentComponent extends ContentBaseComponent<AccordionContentModel> {
}
